var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b(
      { staticClass: "widget-sidebar" },
      "div",
      { style: _setup.style },
      false
    ),
    [
      !_setup.isMobile
        ? _c("div", {
            class: ["resize-handle", { "is-resizing": _setup.isResizing }],
            attrs: { title: "Drag to resize sidebar" },
            on: { mousedown: _setup.startResize },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "sidebarInner", staticClass: "sidebar-inner" }, [
        _c(
          "div",
          { staticClass: "sidebar-header" },
          [
            _c("Transition", { attrs: { name: "bounce" } }, [
              _c(
                "div",
                { key: _setup.headerText, staticClass: "header-content" },
                [
                  _c("div", { staticClass: "h4 mb-0 mr-3" }, [
                    _vm._v(_vm._s(_setup.headerText)),
                  ]),
                  _vm._v(" "),
                  _c("UsageTypeEmblem", {
                    attrs: { type: _setup.usageInfo?.type, text: "" },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { title: "Close sidebar" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c(_setup.Icon, { attrs: { icon: _setup.faXmark } })],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar-body" }, [
          _c("div", { staticClass: "sidebar-section" }, [
            _c("div", { staticClass: "h5 m-0" }, [
              _vm._v(
                "\n          " + _vm._s(_setup.licenseUsageTitle) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column" },
              _vm._l(_setup.displayUsageInfo, function (row) {
                return _c(
                  "div",
                  { key: row.key, staticClass: "d-flex align-items-center" },
                  [
                    _c("div", [_vm._v(_vm._s(row.label))]),
                    _vm._v(" "),
                    _c(_setup.Spacer, { attrs: { type: "dotted" } }),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(row.value))]),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-section" },
            [
              _c("div", { staticClass: "h5 m-0" }, [
                _vm._v("Courses & Participants"),
              ]),
              _vm._v(" "),
              _vm._l(_setup.coursePanels, function (panel) {
                return _c(
                  "div",
                  { key: panel.id, staticClass: "sidebar-panel" },
                  [
                    _c("div", { staticClass: "sidebar-panel-header" }, [
                      _c("div", { staticClass: "sidebar-panel-header-name" }, [
                        _vm._v(
                          "\n              Course: " +
                            _vm._s(panel.name) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _setup.usageInfo?.type === "projected"
                        ? _c(
                            "div",
                            { staticClass: "sidebar-panel-header-actions" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "outline-secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _setup.showCourseInfo(panel.id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                More Info\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "member-list" },
                      _vm._l(panel.members, function (member) {
                        return _c(
                          "div",
                          {
                            key: member.key,
                            class: ["member-list-item", member.typeClass],
                            attrs: { title: member.title },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "member-status" },
                              [
                                _c(_setup.Icon, {
                                  attrs: { icon: member.statusIcon },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "member-info" }, [
                              _vm._v(_vm._s(member.label)),
                            ]),
                            _vm._v(" "),
                            member.action
                              ? _c(
                                  "div",
                                  { staticClass: "member-actions" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-danger" },
                                        on: { click: member.action.fn },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(member.action.text) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }